import './scroll-to-top.scss';
class ScrollToTop {
    constructor (element, options) {
        const defaults = {
            initAttr: 'data-scroll-button',
            onSubmit: null,
            loader: null
        };

        this.settings = Object.assign({}, defaults, options);
        this.button = element;
        this.siteheader = document.querySelector('[data-siteheader="root"]');
        this.actionBar = document.querySelector('[data-fab="root"]');
        this.initialize();
    }

    initialize () {
        if (!this.button) return;
        window.addEventListener('scroll', this.handleScroll.bind(this));

        if (this.actionBar) {
            this.actionBar.classList.add('has--scroll-button');
        }
    }

    handleScroll () {
        const headerHeight = this.siteheader.offsetHeight;
        const scrolledDistance = window.scrollY;

        if (this.actionBar) {
            if (scrolledDistance > headerHeight) {
                this.button.classList.add('scroll-button--is-visible');
                this.actionBar.classList.remove('has--scroll-button');
            } else {
                this.button.classList.remove('scroll-button--is-visible');
                this.actionBar.classList.add('has--scroll-button');
            }
        } else {
            if (scrolledDistance > headerHeight) {
                this.button.classList.add('scroll-button--is-visible');
            } else {
                this.button.classList.remove('scroll-button--is-visible');
            }
        }
    }
}

export { ScrollToTop };

